import '../../styles/web-components/carousel-selector.scss';
import '../../styles/templates/_collection-v2.scss';
import { getAlternateTemplate } from '../services/template.service';
import { refreshWishlistIcons } from '../services/wishlist.service';
import Splide from "@splidejs/splide";
import { DESKTOP_WIDTH, TABLET_WIDTH } from '../vue/constants/devices';
const defaultCarouselOptions = {
    mediaQuery: "min",
    gap: "8px",
    type: 'slide',
    perPage: 2,
    arrows: true,
    pagination: false,
    breakpoints: {
        [TABLET_WIDTH]: {
            perPage: 3
        },
        [DESKTOP_WIDTH]: {
            gap: "24px"
        }
    }
};
class CarouselSelector extends HTMLElement {
    static get observedAttributes() {
        return ["collection-handle"];
    }
    constructor() {
        super();
        this.carousel = null;
        this.loadingSpinner = null;
        this.headerCopy = this.getAttribute('header-copy');
        this.subheaderCopy = this.getAttribute('subheader-copy');
        // normally we'd use the above header and subheader attributes
        // but the design team requested we have a different look for promos
        this.promoTitle = this.getAttribute('promo-title');
        this.promoOffer = this.getAttribute('promo-offer');
        this.promoCode = this.getAttribute('promo-code');
        this.addEventListener('click', async (e) => {
            const target = e.target;
            if (target.matches(".carousel-selector__cta:not(.carousel-selector__cta--selected)")) {
                this.updateHeader(target);
                const collectionHandle = target.dataset.collectionHandle;
                // eslint-disable-next-line wc/no-constructor-attributes
                this.setAttribute('collection-handle', collectionHandle);
            }
        });
        this.addEventListener("click", async (e) => {
            const target = e.target;
            if (target.matches(".js-product-option:not(.product-option--selected)")) {
                e.stopPropagation();
                const initialColorSwatches = target.closest(".product-grid-item-v2__product-swatch-container");
                if (initialColorSwatches) {
                    initialColorSwatches.querySelectorAll(".js-product-option").forEach(c => c.classList.remove("product-option--selected"));
                    target.classList.add("product-option--selected");
                    const initialScrollLeft = initialColorSwatches.scrollLeft;
                    const collectionHandle = target.closest('.js-collection-render-test-result').dataset.collectionHandle;
                    const productHandle = target.dataset.productHandle;
                    const productCardHTML = await getAlternateTemplate(`/collections/${collectionHandle}/products/${productHandle}`, 'plp-card');
                    const productCardEl = target.closest(".boost-pfs-filter-product-item");
                    productCardEl.innerHTML = productCardHTML;
                    const newColorSwatches = productCardEl.querySelector('.product-grid-item-v2__product-swatch-container');
                    newColorSwatches.replaceWith(initialColorSwatches);
                    initialColorSwatches.scrollTo(initialScrollLeft, 0);
                    productCardEl.querySelectorAll('img[data-src]').forEach(img => {
                        img.src = img.dataset.src;
                        img.srcset = img.dataset.srcset || '';
                        img.removeAttribute('data-srcset');
                        img.removeAttribute('data-src');
                    });
                    refreshWishlistIcons('.boost-pfs-filter-products');
                }
            }
        });
        window.addEventListener('resize', () => {
            this.updateArrowPosition();
        });
    }
    connectedCallback() {
        this.render();
        this.loadingSpinner = this.querySelector('loading-spinner');
        this.carousel = new Splide(this.querySelector('.splide'), defaultCarouselOptions);
        this.carousel.mount();
        const firstCta = this.querySelector('.carousel-selector__cta');
        if (firstCta) {
            this.updateHeader(firstCta);
            this.fetchAndRenderCollection(firstCta.dataset.collectionHandle);
        }
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.carousel || oldValue === newValue)
            return;
        switch (name) {
            case 'collection-handle':
                this.fetchAndRenderCollection(newValue);
                break;
            default:
                break;
        }
    }
    render() {
        this.innerHTML = `
    <div class="carousel-selector__container">
      <div class="carousel-selector__left-container">
        <div class="carousel-selector__header-container"></div>
        <div class="carousel-selector__cta-container">
          ${this.renderCTAs()}
        </div>
      </div>
      <div class="carousel-selector__right-container js-collection-render-test-result">
        <loading-spinner show="false"></loading-spinner>
        <section class="splide">
          <div class="splide__track">
            <ul class="splide__list"></ul>
          </div>
        </section>
      </div>
      </div>`;
    }
    renderCTAs() {
        return [1, 2, 3].map(i => {
            if (this.getAttribute(`cta-copy-${i}`) && this.getAttribute(`cta-handle-${i}`)) {
                return `
          <button
            class="carousel-selector__cta"
            data-collection-handle="${this.getAttribute(`cta-handle-${i}`)}"
            data-cta-header="${this.getAttribute(`cta-header-copy-${i}`) || ''}"
            data-cta-subheader="${this.getAttribute(`cta-subheader-copy-${i}`) || ''}"
            data-cta-promo-title="${this.getAttribute(`cta-promo-title-${i}`) || ''}"
            data-cta-promo-offer="${this.getAttribute(`cta-promo-offer-${i}`) || ''}"
            data-cta-promo-code="${this.getAttribute(`cta-promo-code-${i}`) || ''}"
          >
            ${this.getAttribute(`cta-copy-${i}`)}
          </button>`;
            }
            return '';
        }).join('');
    }
    async fetchAndRenderCollection(collectionHandle) {
        var _a;
        console.log('Collection Handle:', collectionHandle);
        this.querySelectorAll('.carousel-selector__cta').forEach(c => {
            if (c.dataset.collectionHandle === collectionHandle) {
                c.classList.add('carousel-selector__cta--selected');
            }
            else {
                c.classList.remove('carousel-selector__cta--selected');
            }
        });
        // Fetch and render the collection data here
        const resp = await fetch(`/collections/${collectionHandle}?sections=collection-product-cards`);
        const json = await resp.json();
        const parser = new DOMParser();
        const doc = parser.parseFromString(json['collection-product-cards'], 'text/html');
        const styles = new Set(doc.querySelectorAll('link[rel="stylesheet"]'));
        styles.forEach(style => {
            if (!document.head.querySelector(`link[href="${style.href.replace("https:", "")}"]`)) {
                document.head.appendChild(style);
            }
        });
        const productList = Array.from(doc.querySelectorAll(".boost-pfs-filter-product-item")).slice(0, 10).map(el => {
            const li = document.createElement('li');
            li.className = 'splide__slide';
            li.appendChild(el);
            return li;
        });
        const results = this.querySelector('.js-collection-render-test-result ul');
        results.replaceChildren(...productList);
        results.dataset.collectionHandle = collectionHandle;
        results.querySelectorAll('img[data-src]').forEach((img, i) => {
            if (i === 0) {
                img.addEventListener('load', () => {
                    this.updateArrowPosition();
                }, { once: true });
            }
            img.src = img.dataset.src;
            img.srcset = img.dataset.srcset || '';
            img.removeAttribute('data-srcset');
            img.removeAttribute('data-src');
        });
        (_a = this.carousel) === null || _a === void 0 ? void 0 : _a.refresh().go(0);
        refreshWishlistIcons('.boost-pfs-filter-products');
    }
    updateArrowPosition() {
        if (this.carousel) {
            const arrows = this.carousel.root.querySelectorAll('.splide__arrow');
            const firstSlide = this.carousel.Components.Elements.slides[0];
            if (firstSlide) {
                const slideImg = firstSlide.querySelector('.boost-pfs-filter-product-item-image');
                if (slideImg) {
                    const imgHeight = slideImg.offsetHeight;
                    if (imgHeight === 0)
                        return;
                    arrows.forEach(arrow => {
                        arrow.style.top = `${imgHeight / 2}px`;
                    });
                }
            }
        }
    }
    updateHeader(target) {
        if (target.dataset.ctaHeader) {
            this.headerCopy = target.dataset.ctaHeader;
        }
        if (target.dataset.ctaSubheader) {
            this.subheaderCopy = target.dataset.ctaSubheader;
        }
        if (target.dataset.ctaPromoTitle) {
            this.promoTitle = target.dataset.ctaPromoTitle;
        }
        if (target.dataset.ctaPromoOffer) {
            this.promoOffer = target.dataset.ctaPromoOffer;
        }
        if (target.dataset.ctaPromoCode) {
            this.promoCode = target.dataset.ctaPromoCode;
        }
        const headerContainer = this.querySelector('.carousel-selector__header-container');
        if (headerContainer) {
            console.log("Updating header to:", this.headerCopy, this.subheaderCopy);
            headerContainer.innerHTML = `
        ${this.headerCopy ? `<h2 class="carousel-selector__header">${this.headerCopy}</h2>` : ''}
        ${this.subheaderCopy ? `<p class="carousel-selector__subheader">${this.subheaderCopy}</p>` : ''}
        ${this.promoTitle ? `<h2 class="carousel-selector__promo-title">${this.promoTitle}</h2>` : ''}
        ${this.promoOffer ? `<p class="carousel-selector__promo-offer">${this.promoOffer}</p>` : ''}
        ${this.promoCode ? `<p class="carousel-selector__promo-code">${this.promoCode}</p>` : ''}`;
        }
    }
}
if (!window.customElements.get("carousel-selector")) {
    customElements.define("carousel-selector", CarouselSelector);
}
